export * from './skyscraper3.component';